//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const TotalPreDevelopmentCostWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Pre-Development Costs' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalPreDevelopmentCostWidget;
